import { ExclamationCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import {
    Button,
    Modal,
    notification,
    Popover,
    Tag,
    Tooltip,
    Typography
} from 'antd';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
import { format, addDays } from 'date-fns'

import { useSelector } from 'react-redux';
import { stateGlobal } from '../../../../interfaces/Global';

import Icon from '@ant-design/icons';
import { IoArrowUndoSharp } from 'react-icons/io5';
import { mask, unMask } from '../../../../utils/MascaraDeCampos';
import { getToken } from '../../../../services/token';

import { FaSearch, FaWhatsapp } from 'react-icons/fa';
import {
    urlContratoVendedores,
    urlUsers,
    urlUsersStatusAtivos,
    urlUsersStatusInativos,
    urlUsersStatusTodos,
} from '../../../../services/request/urls';
import { useGetColumnSearchPropsData } from '../../../../hooks/FilterTable/date';
import { useGetColumnSearchProps } from '../../../../hooks/FilterTable/stringCLearFiltros';
import { useGetColumnSearchPropsObj } from '../../../../hooks/FilterTable/objString';
import SolicitacoesDeUpgradeService from '../../../../services/http/services/Contratos/SolicitacoesDeUpgradeService';
import { IreqSolicitacoesUpgrade, IreqSolicitacoesUpgradeItem } from './interface';
import { useGetColumnSearchPropsBoolean } from '../../../../hooks/FilterTable/boolean';
import { useGetColumnSearchPropsObjContratoPlano } from './filterTablePlano';
import { convertDataEHoraBrParaUS } from '../../../../services/Conversores';

const { Text } = Typography;

const IconSerach = (props: any) => <Icon {...props} component={FaSearch} ></Icon>
const IconWhatsApp = (props: any) => <Icon {...props} component={FaWhatsapp} ></Icon>

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

interface tabelaUsuarios {
    id: number,
    uuid: string,
    sistema: string,
    ativo: boolean,
    nome: string,
    celular: string,
    email: string,
    testador: boolean,
    dias_de_teste: string | number | null,
    vendedor: boolean,
    avatar: string | null,
    created_at: string,
    updated_at: string,
    cargo: { id: number, nome: string }
}

export const useSolicitacoesDeUpgrade = () => {

    const refFormModal = useRef<any>(null);

    const refValorSelecioneFiltro = React.useRef<string>('Usuários');
    const refContagemDoFiltro = React.useRef<Array<any>>([]);

    const propsState = useSelector((state: stateGlobal) => state.global);
    const queryParans = useQuery();

    const history = useHistory();
    //para poder cancelar a requisição
    const signal = axios.CancelToken.source();
    const signal1 = axios.CancelToken.source();

    const [selectedRowKeys, setSelectedRowKeys] = useState<Array<string>>([]);
    const [dadosTabelaState, setDadosTabelaState] = useState<IreqSolicitacoesUpgrade | null>(null);
    const [hasSelectedEdit, setHasSelectedEdit] = useState(false);
    const [loadingTable, setLoadingTable] = useState(false);
    const [valorSelecione, setValorSelecione] = useState('Usuários');


    const [visibleAlertDeAtencaoCache, setVisibleAlertDeAtencaoCache] = useState(false);
    const [spinAlertDeAtencaoCache, setSpinAlertDeAtencaoCache] = useState(false);
    const [ativarOuInativarModulo, setAtivarOuInativarModulo] = useState(false);

    const [visibleModal, setVisibleModal] = useState(false);
    const [solicitacaoUpSelected, setSolicitacaoUpSelected] = useState<IreqSolicitacoesUpgradeItem | null>(null);
    const refSolicitacaoEncontrada = useRef<IreqSolicitacoesUpgradeItem | null>(null);

    const [selectedDateVincularUserRapido, setSelectedDateVincularUserRapido] = useState<any>(null);

    const buscaDadosTodosusuariosAndSetTable = useCallback((): void => {

        setLoadingTable(true)
        const buscaDeDadosVerndedores = async () => {
            try {


                const data = await SolicitacoesDeUpgradeService.getSolicitacaoUpgrade(signal.token)

                setDadosTabelaState(data);
                setLoadingTable(false);

            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDadosVerndedores();

    }, []);

    const buscaDadosUsuariosAtivosAndSetTable = useCallback((): void => {

        setLoadingTable(true)
        const buscaDeDadosUsuarios = async () => {
            try {

                const data = await SolicitacoesDeUpgradeService.getSolicitacaoUpgrade(signal.token)

                setDadosTabelaState(data);
                setLoadingTable(false)

            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDadosUsuarios();

    }, []);

    const mensagemDeAtencaoNaTelaPeloCache = useCallback((semParam?: boolean): void => {

        let atencaoParam = queryParans.get("at");
        // comenntado pois não esta utilizando a atualizacao do cache
        // if (
        //     atencaoParam &&
        //     parseInt(atencaoParam)
        //     && parseInt(atencaoParam) === 1
        // ) {
        //     setVisibleAlertDeAtencaoCache(true);
        //     setSpinAlertDeAtencaoCache(true);

        //     setTimeout(() => {
        //         setSpinAlertDeAtencaoCache(false);

        //         // 22 segundos
        //     }, 22000);
        // }

        // if (semParam) {
        //     setVisibleAlertDeAtencaoCache(true);
        //     setSpinAlertDeAtencaoCache(true);

        //     setTimeout(() => {
        //         setSpinAlertDeAtencaoCache(false);

        //         // 15 segundos
        //     }, 15000);
        // }

    }, []);

    //executa apenas ao iniciar o component
    useEffect(() => {

        buscaDadosUsuariosAtivosAndSetTable();

        // Data do prox contato default is true então iniciar com 15dias
        let dataEHoraSomada = format(
            addDays(
                new Date(),
                15
            )
            , 'yyyy-MM-dd HH:mm'
        )

        setTimeout(() => {
            setSelectedDateVincularUserRapido(moment(dataEHoraSomada))
        }, 500);

    }, []);

    //executa apenas quando desmonta o component
    const comonentExecutaAoDestroy = useEffect(() => () => {
        signal.cancel("Requisicao cancelada!")
        signal1.cancel("Requisicao cancelada!")
    }, []);

    const buscaDadosVendedoresAndSetTable = useCallback((): void => {

        setLoadingTable(true)
        const buscaDeDadosVerndedores = async () => {
            try {
                let result = await axios.get(urlContratoVendedores,
                    {
                        headers: { 'Authorization': 'Bearer ' + getToken() },
                        cancelToken: signal.token
                    });

                setDadosTabelaState(result.data);
                setLoadingTable(false);

            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDadosVerndedores();

    }, []);

    const buscaDadosUsuariosInativosAndSetTable = useCallback((): void => {

        setLoadingTable(true)
        const buscaDeDadosUsuarios = async () => {
            try {
                let result = await axios.get(urlUsersStatusInativos,
                    {
                        headers: { 'Authorization': 'Bearer ' + getToken() },
                        cancelToken: signal.token
                    });

                setDadosTabelaState(result.data);
                setLoadingTable(false)

            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDadosUsuarios();

    }, []);


    //abrir navegar em add contrato
    const clickBotaoEditarUsuario = useCallback((): void => {

        // const buscaDeDados = async () => {
        const buscaDeDados = () => {

            if (selectedRowKeys.length == 1) {

                let objSelecionado: any = {}
                dadosTabelaState?.solicitacoes.forEach((dados): void => {
                    if (dados.uuid == selectedRowKeys[0]) {
                        objSelecionado.step1 = dados
                        objSelecionado.idUser = dados.id;
                        // objSelecionado.step1.cargo_id = dados.cargo.id;
                    }
                })

                try {
                    // let resultVendedores = await axios.get(urlContratoVendedores + '/' + objSelecionado?.id,
                    //     { headers: { 'Authorization': 'Bearer ' + getToken() } });

                    //     objSelecionado.vendedores = resultVendedores.data;

                    //     let resultEstados = await axios.get(urlContratoEstados + '/' + objSelecionado?.id,
                    //         { headers: { 'Authorization': 'Bearer ' + getToken() } });

                    //     objSelecionado.modo_estado = resultEstados.data;


                    //     objSelecionado.cidades = resultCidades.data;

                    objSelecionado.isEdit = true;

                    localStorage.setItem('@GovFacil:userDataAtualizarESair', JSON.stringify(objSelecionado));
                    localStorage.setItem('@GovFacil:userData', JSON.stringify(objSelecionado));

                    history.push("/usuarios/adicionar");
                } catch (error) {
                    let msgErro: any = (error as Error);
                    notification.error({
                        message: 'Erro',
                        description:
                            msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Erro entre em contato com o suporte!',
                    });
                }

            }
        }

        buscaDeDados();

    }, [selectedRowKeys, dadosTabelaState]);

    const requestAtivarOuInativarUser = useCallback((obj): void => {
        setLoadingTable(true);
        const buscaDeDados = async () => {
            // if (selectedRowKeys.length == 1 || selectedRowKeys.length > 1) {
            if (selectedRowKeys.length == 1) {
                let linha: any = [];
                dadosTabelaState?.solicitacoes.forEach(({ uuid, id }): void => {

                    selectedRowKeys.forEach((val, i) => {
                        if (uuid == val) {
                            linha.push({ id })
                        }
                    });

                })

                try {
                    await axios.patch(urlUsers + "/" + linha[0].id, obj, {
                        //EXEMPLO APENAS PARA EXCLUIR UM [0] ATE CORRIGIR O BACK
                        headers: { 'Authorization': 'Bearer ' + getToken() }
                    })

                    setLoadingTable(false);
                    // if (obj.ativo) {
                    //     buscaDadosUsuariosInativosAndSetTable();
                    // } else {
                    //     buscaDadosUsuariosAtivosAndSetTable();
                    // }

                    if (valorSelecione === 'Usuários') {

                        buscaDadosUsuariosAtivosAndSetTable();

                    } else if (valorSelecione === 'Vendedores') {

                        buscaDadosVendedoresAndSetTable();
                    } else if (valorSelecione === 'Inativos') {

                        buscaDadosUsuariosInativosAndSetTable();
                    } else if (valorSelecione === 'Todos') {

                        buscaDadosTodosusuariosAndSetTable();
                    }

                    mensagemDeAtencaoNaTelaPeloCache(true);

                    notification.success({
                        message: 'Sucesso',
                        description:
                            `O usuario foi ${obj.ativo ? 'ativado' : 'inativado'} com sucesso!`,
                    });
                } catch (error) {
                    setLoadingTable(false);
                    notification.error({
                        message: 'Erro',
                        description:
                            `Não foi possivel
                        ${obj.ativo ? 'ativar' : 'inativar'}
                         o usuario, entre em contato com suporte!`
                    });
                }
                setHasSelectedEdit(false);
                setSelectedRowKeys([]);

            }
        }

        buscaDeDados();
    }, [selectedRowKeys, dadosTabelaState, buscaDadosUsuariosAtivosAndSetTable, buscaDadosUsuariosInativosAndSetTable, valorSelecione]);

    const TextAtivarInativar = (props: any) => <Text>{props.text} <br />Tem certeza que deseja continuar?</Text>;

    const onClickInativarUser = useCallback((): void => {
        Modal.confirm({
            title: 'Cuidado',
            icon: <ExclamationCircleOutlined />,
            content: <TextAtivarInativar text='O usuário perderá todo acesso ao sistema!' />,
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                requestAtivarOuInativarUser({ ativo: false });
            },
            onCancel() {
            },
        });
    }, [requestAtivarOuInativarUser]);

    const onClickAtivarUser = useCallback((): void => {
        Modal.confirm({
            title: 'Cuidado',
            icon: <ExclamationCircleOutlined />,
            content: <TextAtivarInativar text='O usuário terá acesso ao sistema novamente!' />,
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                requestAtivarOuInativarUser({ ativo: true });
            },
            onCancel() {
            },
        });
    }, [requestAtivarOuInativarUser]);

    //click add usuario
    const navigateAddUser = useCallback((): void => {
        let dadosLocalStorage: string | null = localStorage.getItem('@GovFacil:userData');
        let localUserData: any = null;
        if (typeof dadosLocalStorage == 'string') {
            localUserData = JSON.parse(dadosLocalStorage);
        }

        if (localUserData) {
            localStorage.removeItem('@GovFacil:userData');
        }

        history.push("/usuarios/adicionar");
    }, []);

    const onChangeSelectFiltroBuscaTabela = useCallback((e): void => {
        refValorSelecioneFiltro.current = e
        //setando valor do selecione em stado para caso for inativo renderizar outro botao
        setValorSelecione(e);
        switch (e) {
            case 'Inativos':
                buscaDadosUsuariosInativosAndSetTable();
                break;
            case 'Usuários':
                buscaDadosUsuariosAtivosAndSetTable();
                break;
            case 'Vendedores':
                buscaDadosVendedoresAndSetTable();
                break;
            case 'Todos':
                buscaDadosTodosusuariosAndSetTable();
                break;

            default:
                buscaDadosUsuariosAtivosAndSetTable();
                break;
        }
    }, []);

    //executa ao iniciar e did update para atualizar o botao de ativo ou inativo
    useEffect(() => {
        const buscaDeDados = async () => {
            try {
                if (selectedRowKeys.length === 1) {
                    dadosTabelaState?.solicitacoes.forEach((objEditar: any): void => {
                        if (objEditar.uuid === selectedRowKeys[0]) {
                            // obj.push(objEditar)
                            setAtivarOuInativarModulo(objEditar.ativo)
                        }
                    })


                }


            } catch (error) {

            }
        }

        buscaDeDados();

    }, [selectedRowKeys]);

    const clickBotaoDeletarDados = useCallback((): void => {
        const requestAsync = () => {
            // if (selectedRowKeys.length == 1 || selectedRowKeys.length > 1) {
            if (selectedRowKeys.length == 1) {
                let linha: any = [];
                dadosTabelaState?.solicitacoes.forEach(({ uuid, id }): void => {

                    selectedRowKeys.forEach((val, i) => {
                        if (uuid == val) {
                            linha.push({ id })
                        }
                    });

                })

                const excluirDadosModal = async () => {
                    try {
                        setLoadingTable(true)

                        await axios.delete(urlUsers + '/' + linha[0].id, {
                            headers: { 'Authorization': 'Bearer ' + getToken() }
                        })

                        notification.success({
                            message: 'Sucesso',
                            description:
                                'Usuário deletado com sucesso.',
                        });
                        onChangeSelectFiltroBuscaTabela(refValorSelecioneFiltro.current)

                        setLoadingTable(false)

                        setHasSelectedEdit(false);
                        setSelectedRowKeys([]);
                    } catch (error: any) {
                        setLoadingTable(false)
                        notification.error({
                            message: 'Erro',
                            description:
                                error?.response?.data?.message ? error?.response?.data?.message : 'Não foi possível deletar, entre em contato com suporte!',
                        });
                    }
                }
                excluirDadosModal();

            }
        }

        Modal.confirm({
            className: 'classmodalDadosContatoInatendimento',
            title: 'Atenção',
            icon: <ExclamationCircleOutlined />,
            content: `A exclusão do usuário é irreversível e ele não poderá mais ser encontrado. Deseja realmente excluir?`
            ,
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                requestAsync();
            },
            onCancel() {
            },
        });

    }, [selectedRowKeys, dadosTabelaState]);

    const returnCorTag = useCallback((tag: boolean) => {
        let cor = '';
        let nome = '';
        switch (tag) {
            case true:
                cor = 'green';
                nome = 'SIM';
                break;
            case false:
                cor = 'blue';
                nome = 'NÃO';
                break;

            default:
                cor = ''
                break;
        }

        return { color: cor, children: nome }
    }, []);

    // click na linha da tabela de listagem de usuario
    const onclickTable = useCallback((record: any, row: any): void => {

        if (selectedRowKeys.includes(record.uuid)) {
            let filter = selectedRowKeys.filter((val) => {
                return val != record.uuid
            })
            if (filter.length === 1) {
                setSelectedRowKeys(filter);
                setHasSelectedEdit(true);
            } else if (filter.length === 0) {
                setSelectedRowKeys(filter);
                setHasSelectedEdit(false);
            } else {
                setSelectedRowKeys(filter);
            }

        } else {
            if (selectedRowKeys.length == 0) {
                setSelectedRowKeys([record.uuid]);
                setHasSelectedEdit(true);
            } else {
                let teste = selectedRowKeys.concat(record.uuid);
                setSelectedRowKeys(teste);
                setHasSelectedEdit(false);
            }
        }
    }, [selectedRowKeys]);

    //checkbox da tabela de listagem
    const onSelectChange = useCallback((selectedRowKeys): void => {
        if (selectedRowKeys.length > 1) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(false);
        } else if (selectedRowKeys.length === 0) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(false);
        } else {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(true);
        }
    }, [selectedRowKeys]);

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: '1%'
    };

    const refFuncaoLimparFiltrosStringObservacao = useRef<any>(null);
    const columnSearchPropsModuloNome = useGetColumnSearchPropsObj('modulo');
    const columnSearchPropsContratoNome = useGetColumnSearchPropsObj('contrato');
    const columnSearchPropsUsuarioNome = useGetColumnSearchPropsObj('usuario');
    const columnSearchPropsBooleanAtendida = useGetColumnSearchPropsBoolean('atendida', 'sim', 'nao');
    const columnSearchPropsPlano = useGetColumnSearchPropsObjContratoPlano('contrato');
    const columnSearchPropsObservacao = useGetColumnSearchProps('observacao', refFuncaoLimparFiltrosStringObservacao);

    const columns = [
        {
            title: 'Módulo',
            dataIndex: 'modulo',
            ...columnSearchPropsModuloNome,
            width: '10%',
            sorter: (a: any, b: any) => a.modulo.nome.localeCompare(b.modulo.nome),
            showSorterTooltip: false,
            render: (modulo: any, record: any) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        {
                            <Text>{modulo?.nome}</Text>
                        }
                    </div>
                )
            },
        },
        {
            title: 'Contrato',
            dataIndex: 'contrato',
            key: 'contratoNome',
            ...columnSearchPropsContratoNome,
            width: '10%',
            sorter: (a: any, b: any) => a?.contrato?.nome.localeCompare(b?.contrato?.nome),
            showSorterTooltip: false,
            render: (contrato: any, record: any) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        {
                            <Text>{contrato?.nome}</Text>
                        }
                    </div>
                )
            },
        },
        {
            title: 'Plano',
            dataIndex: 'contrato',
            key: 'contratoPlanoNome',
            ...columnSearchPropsPlano,
            width: '10%',
            sorter: (a: any, b: any) => a?.contrato?.plano?.nome?.localeCompare(b?.contrato?.plano?.nome),
            showSorterTooltip: false,
            render: (contrato: any, record: any) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        {
                            <Text>{contrato?.plano?.nome}</Text>
                        }
                    </div>
                )
            },
        },
        {
            title: 'Atendida',
            dataIndex: 'atendida',
            ...columnSearchPropsBooleanAtendida,
            width: '10%',
            render: (val: any) => {

                return (
                    <span>
                        <Tag {...returnCorTag(val)} />
                    </span>
                )
            },
        },
        {
            title: 'Usuário',
            dataIndex: 'usuario',
            ...columnSearchPropsUsuarioNome,
            width: '10%',
            sorter: (a: any, b: any) => a.usuario.nome.localeCompare(b.usuario.nome),
            showSorterTooltip: false,
            render: (usuario: any, record: any) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        {
                            <Text>{usuario?.nome}</Text>
                        }
                    </div>
                )
            },
        },
        {
            title: 'Observação',
            dataIndex: 'observacao',
            ...columnSearchPropsObservacao,
            width: '10%',
            sorter: (a: any, b: any) => a.observacao.localeCompare(b.observacao),
            showSorterTooltip: false,
            render: (text: any) => {

                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    }}>
                        <Text style={{ marginRight: 4 }}>
                            {text?.length > 20 ? text.substring(0, 20) + '...' : text}
                        </Text>
                        {text?.length > 20 ?
                            <Popover
                                style={{ height: 80 }}
                                overlayClassName="popOverlayTaxaDeJuros_vchvbqweyuv"
                                content={text}
                                trigger="click"
                            >
                                <Button onClick={(e) => e?.stopPropagation()} size="small"><PlusCircleOutlined /></Button>
                            </Popover>
                            :
                            <></>
                        }
                    </div>

                )
            },
        },
        {
            title: 'Criado',
            dataIndex: 'createdAt',
            ...useGetColumnSearchPropsData('createdAt'),
            width: '2%',
            sorter: (a: any, b: any) => {

                let aMonMen: any = null
                let bMonMen: any = null
                if (a.created_at) {
                    aMonMen = moment(a.created_at).unix()
                } else {
                    aMonMen = 0
                }
                if (b.created_at) {
                    bMonMen = moment(b.created_at).unix()
                } else {
                    bMonMen = 0
                }

                return aMonMen - bMonMen
            },
            showSorterTooltip: false,
            // sorter: (a: any, b: any) => a.created_at.localeCompare(b.created_at),
            render: (criado: any) => (
                moment(criado).format('DD/MM/YYYY HH:mm')
            ),
        },
    ];


    const navigateGerenciar = useCallback(() => {
        history.push(`/solicitacoes-de-ativacao/gerenciar/add`)
    }, []);

    const handleAtender = useCallback(() => {
        const requestAsync = async () => {
            try {
                setLoadingTable(true)
                setVisibleModal(true)

                if (selectedRowKeys.length === 1 && dadosTabelaState?.solicitacoes) {

                    const selectedUuid = selectedRowKeys[0];

                    const solicitacaoEncontrada = dadosTabelaState.solicitacoes.find(
                        (solicitacao) => solicitacao.uuid === selectedUuid
                    );

                    if (solicitacaoEncontrada) {
                        const idDaSolicitacao = solicitacaoEncontrada.id;

                        const data = await SolicitacoesDeUpgradeService.getSolicitacaoUpgradeById(idDaSolicitacao, signal.token)

                        refSolicitacaoEncontrada.current = data
                        setSolicitacaoUpSelected(data);

                    }

                }

                setLoadingTable(false)

            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Erro entre em contato com o suporte!',
                    });
                }
            }
        }

        requestAsync();

    }, [selectedRowKeys, dadosTabelaState]);


    const clickCloseModalSolicitacaoUpgrade = useCallback((): void => {
        refSolicitacaoEncontrada.current = null
        setSolicitacaoUpSelected(null)
        setLoadingTable(false)
        setVisibleModal(false)

        setSelectedRowKeys([]);
        setHasSelectedEdit(false);
    }, []);

    const clickSubmitModalSolicitacaoUpgrade = useCallback((): void => {

        setLoadingTable(true);

        const requestAsync = async (values: any) => {
            try {

                if (refSolicitacaoEncontrada.current) {
                    const data = await SolicitacoesDeUpgradeService.patchSolicitacaoUpgrade(refSolicitacaoEncontrada.current.id, values, signal.token)

                }
                clickCloseModalSolicitacaoUpgrade();
                setLoadingTable(false)

            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Erro entre em contato com o suporte!',
                    });
                }
            }
        }


        refFormModal.current?.validateFields()
            .then((values: any) => {

                values = {
                    ...values,
                    dataProximoContato: selectedDateVincularUserRapido && selectedDateVincularUserRapido != '' ?
                        convertDataEHoraBrParaUS(selectedDateVincularUserRapido, true)
                        : undefined,
                }

                requestAsync(values);
            })
            .catch((errorInfo: any) => {
                const fieldWithError = errorInfo.errorFields[0].name[0];
                refFormModal.current.getFieldInstance(fieldWithError).focus();

                setLoadingTable(false);
                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });

            });

    }, [selectedDateVincularUserRapido]);


    return {
        navigateAddUser,
        clickBotaoEditarUsuario,
        hasSelectedEdit,
        onChangeSelectFiltroBuscaTabela,
        selectedRowKeys,
        ativarOuInativarModulo,
        onClickInativarUser,
        onClickAtivarUser,
        clickBotaoDeletarDados,
        visibleAlertDeAtencaoCache,
        spinAlertDeAtencaoCache,
        setVisibleAlertDeAtencaoCache,
        setSpinAlertDeAtencaoCache,
        valorSelecione,
        buscaDadosUsuariosAtivosAndSetTable,
        buscaDadosVendedoresAndSetTable,
        buscaDadosUsuariosInativosAndSetTable,
        buscaDadosTodosusuariosAndSetTable,
        loadingTable,
        onclickTable,
        rowSelection,
        dadosTabelaState,
        columns,
        refContagemDoFiltro,
        propsState,
        navigateGerenciar,
        visibleModal,
        setVisibleModal,
        handleAtender,
        solicitacaoUpSelected,
        returnCorTag,
        refFormModal,
        clickSubmitModalSolicitacaoUpgrade,
        selectedDateVincularUserRapido,
        setSelectedDateVincularUserRapido,
        clickCloseModalSolicitacaoUpgrade,
    }
}
